import { ElNotification } from 'element-plus'

/**
 * 全局通知服务
 * 封装Element Plus的ElNotification，提供统一的成功和错误提示功能
 */
class NotificationService {
    /**
     * 显示成功通知
     * @param {string} message - 通知消息内容
     * @param {string} title - 通知标题，默认为'成功'
     * @param {number} duration - 显示持续时间，单位毫秒，默认为3000ms
     */
    success(message, title = '成功', duration = 3000) {
        ElNotification({
            title,
            message,
            type: 'success',
            duration,
            offset: 30,
            position: 'top-right'
        })
    }

    /**
     * 显示错误通知
     * @param {string} message - 通知消息内容
     * @param {string} title - 通知标题，默认为'错误'
     * @param {number} duration - 显示持续时间，单位毫秒，默认为3000ms
     */
    error(message, title = '错误', duration = 3000) {
        ElNotification({
            title,
            message,
            type: 'error',
            duration,
            offset: 30,
            position: 'top-right'
        })
    }

    /**
     * 显示警告通知
     * @param {string} message - 通知消息内容
     * @param {string} title - 通知标题，默认为'警告'
     * @param {number} duration - 显示持续时间，单位毫秒，默认为3000ms
     */
    warning(message, title = '警告', duration = 3000) {
        ElNotification({
            title,
            message,
            type: 'warning',
            duration,
            offset: 30,
            position: 'top-right'
        })
    }

    /**
     * 显示信息通知
     * @param {string} message - 通知消息内容
     * @param {string} title - 通知标题，默认为'信息'
     * @param {number} duration - 显示持续时间，单位毫秒，默认为3000ms
     */
    info(message, title = '信息', duration = 3000) {
        ElNotification({
            title,
            message,
            type: 'info',
            duration,
            offset: 30,
            position: 'top-right'
        })
    }

    /**
     * 通用通知方法
     * @param {string} message - 通知消息内容
     * @param {string} title - 通知标题
     * @param {'success'|'error'|'warning'|'info'} type - 通知类型
     * @param {number} duration - 显示持续时间，单位毫秒，默认为3000ms
     */
    notify(message, title, type = 'info', duration = 3000) {
        ElNotification({
            title,
            message,
            type,
            duration,
            offset: 30,
            position: 'top-right'
        })
    }
}

// 创建全局实例
const notificationService = new NotificationService()

// 导出实例和类
export { notificationService, NotificationService }

// 也可以直接导出实例作为默认导出
export default notificationService